<template>
  <div class="fixed right-6 top-1/2 -translate-y-1/2 z-50 hidden lg:block">
    <div class="bg-white rounded-lg shadow-2xl overflow-hidden border border-gray-200">
      <!-- Phone -->
      <a
        href="tel:400-852-6298"
        class="flex flex-col items-center justify-center p-4 transition-colors border-b border-gray-200 group hover:bg-gray-50"
      >
        <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-colors" style="background-color: rgba(212, 175, 55, 0.2);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-[#0A2463]">
            <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
          </svg>
        </div>
        <span class="text-sm text-gray-900 whitespace-nowrap">{{ $t('sideBar.phone') }}</span>
      </a>

      <!-- Email -->
      <a
        href="mailto:Leviygo@leviyglobal.com"
        class="flex flex-col items-center justify-center p-4 transition-colors border-b border-gray-200 group hover:bg-gray-50"
      >
        <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-colors" style="background-color: rgba(212, 175, 55, 0.2);">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-[#0A2463]">
            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
            <rect x="2" y="4" width="20" height="16" rx="2"></rect>
          </svg>
        </div>
        <span class="text-sm text-gray-900 whitespace-nowrap">{{ $t('sideBar.email') }}</span>
      </a>

      <!-- WeChat -->
      <a
        href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0NTY3NDIyMA==&scene=110#wechat_redirect"
        target="_blank"
        rel="noopener noreferrer"
        class="flex flex-col items-center justify-center p-4 transition-colors group relative hover:bg-gray-50"
      >
        <div class="w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-colors" style="background-color: rgba(212, 175, 55, 0.2);">
          <svg class="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" style="color: rgb(10, 36, 99);">
            <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1 .178-.555c1.529-1.119 2.5-2.834 2.5-4.663 0-3.249-3.014-5.954-6.706-6.08h-.354zm-1.78 2.668c.514 0 .93.426.93.95a.94.94 0 0 1-.93.95.94.94 0 0 1-.93-.95c0-.524.416-.95.93-.95zm3.6 0c.513 0 .93.426.93.95a.94.94 0 0 1-.93.95.94.94 0 0 1-.93-.95c0-.524.417-.95.93-.95z"></path>
          </svg>
        </div>
        <span class="text-sm text-gray-900 whitespace-nowrap">{{ $t('sideBar.wechat') }}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
</script>
